import { NavigationStepper } from './navigation-stepper';
import { useVisitNavigation } from '@/contexts/visit-navigation-context';
import styles from './visit-navigation.module.css';

export function VisitNavigation() {
  const { steps, editMode } = useVisitNavigation();

  return (
    <NavigationStepper
      steps={steps}
      className={styles.visitNavigation}
      isNonInteractive={editMode !== null}
    />
  );
}
